/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'
import Button from '/overrides/app/components/button'

/**
 * Renders a form submit button and a cancel button with configurable labels and callbacks
 * in a responsive layout. Used primarily in forms that can be toggled opened/closed.
 */
const FormActionButtons = ({
    saveButtonProps = {},
    cancelButtonProps = {},
    saveButtonLabel,
    cancelButtonLabel,
    onCancel = () => {}
}) => {
    const {tShipping} = useTranslationHelpers()
    return (
        <Stack direction={{base: 'column'}} spacing={4}>
            <Button
                variant="solid"
                type="submit"
                minWidth={28}
                alignSelf="center"
                maxWidth="465px"
                width="full"
                {...saveButtonProps}
            >
                {saveButtonLabel ? saveButtonLabel : tShipping?.buttonSaveAndContinue}
            </Button>
            <Button
                variant="outline"
                minWidth={28}
                maxWidth="465px"
                width="full"
                alignSelf="center"
                onClick={onCancel}
                {...cancelButtonProps}
            >
                {cancelButtonLabel ? cancelButtonLabel : tShipping?.buttonCancel}
            </Button>
        </Stack>
    )
}

FormActionButtons.propTypes = {
    saveButtonProps: PropTypes.object,
    cancelButtonProps: PropTypes.object,
    saveButtonLabel: PropTypes.string,
    cancelButtonLabel: PropTypes.string,
    onCancel: PropTypes.func
}

export default FormActionButtons
